import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { AdminAuthProvider, UserAuthProvider } from "./auth";
import { installDevelopmentRequestLogging } from "./development-debug-log";
import "./styles.css";

void installDevelopmentRequestLogging().finally(() => {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <BrowserRouter>
        <UserAuthProvider>
          <AdminAuthProvider>
            <App />
          </AdminAuthProvider>
        </UserAuthProvider>
      </BrowserRouter>
    </StrictMode>,
  );
});
